var hash = {
  start: 'end',
  end: 'start'
};
export default function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}


//////////////////
// WEBPACK FOOTER
// ../@popperjs/core/lib/utils/getOppositeVariationPlacement.js
// module id = 1691
// module chunks = 22